import { useTranslation } from 'react-i18next';
import { FilterAction } from '@anytag/shared-types';
import { TableSegment } from '@anytag/shared-atoms';
import { AffiliateReportShowBy, MarketplaceAffiliateReportSummary } from '@anytag/graphql';
import { MarketplaceAffiliateReportFilterFormValues } from '../MarketplaceAffiliateReportFilter';
import { MarketplaceAffiliateReportByDateTable } from './MarketplaceAffiliateReportByDateTable';
import { MarketplaceAffiliateReportByInfluencerTable } from './MarketplaceAffiliateReportByInfluencerTable';

export interface MarketplaceAffiliateReportTableProps extends FilterAction<MarketplaceAffiliateReportFilterFormValues> {
  currency: string;
  campaignId: number;
  isReferralCampaign?: boolean;
  summaryData?: MarketplaceAffiliateReportSummary;
}

export const MarketplaceAffiliateReportTable = ({
  filter,
  currency,
  setFilter,
  campaignId,
  summaryData,
  isReferralCampaign
}: MarketplaceAffiliateReportTableProps) => {
  const { t } = useTranslation();

  const isShowByDate = filter.mode === AffiliateReportShowBy.DATE;
  const defaultTableProps = { currency, campaignId, summaryData, isReferralCampaign };

  return (
    <>
      <TableSegment
        type="radio"
        values={[filter.mode]}
        className="report-table-segment"
        onChange={(mode) => setFilter({ mode })}
        options={[
          { value: AffiliateReportShowBy.DATE, label: t('Show by date') },
          { value: AffiliateReportShowBy.INFLUENCER, label: t('Show by Influencer') }
        ]}
      />

      {isShowByDate ? (
        <MarketplaceAffiliateReportByDateTable {...defaultTableProps} />
      ) : (
        <MarketplaceAffiliateReportByInfluencerTable {...defaultTableProps} />
      )}
    </>
  );
};
